<template>
    <div v-if="$store.state.hideFilters === false" class="filter" v-cloak>
        <div class="filter__header">
            <div class="top">
                <h3 class="title">Filter</h3>
                <div @click="toggleFilterVisibility" class="close-filter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                        <path fill="#000"
                              d="m1.2248 13.8248-1.049995-1.05L5.9498 6.9998.174805 1.2248 1.2248.174805 6.9998 5.9498l5.775-5.774995 1.05 1.049995-5.775 5.775 5.775 5.775-1.05 1.05-5.775-5.775-5.775 5.775Z"/>
                    </svg>
                </div>
            </div>
            <button v-if="$store.state.filterState" @click="resetAllFilters" class="filter-reset button">
                <span>Reset all filters</span>
            </button>
            <div v-if="false" class="filter__active-filters">
                <span class="title">Actieve filters</span>
                <div class="active-filters" id="active-filters">
                    <template v-for="visibleFilter in $store.state.Filters">
                        <label v-for="value in visibleFilter.values" :for="value.name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none">
                                <path fill="#47BBE3" d="m1.14995 9.5502-.699999-.70001L4.29995 5.0002l-3.849999-3.85.699999-.700005 3.85 3.850005 3.85-3.850005.7.700005-3.85 3.85 3.85 3.84999-.7.70001-3.85-3.85-3.85 3.85Z"/>
                            </svg>
                            {{ value.name }}
                        </label>
                    </template>
                </div>
            </div>
        </div>
        <div class="filter__wrapper">
            <filter-block v-for="localFilter in localFilters" v-bind:FilterBlock="localFilter"></filter-block>
            <div v-if="$store.state.filterPlacement === 'top'" class="filter-bar__results">
                <span class="number" id="filter-bar-total">-</span>
                <span class="text">resultaten</span>
            </div>
        </div>
        <div class="filter__footer">
            <div @click="toggleFilterVisibility" class="button button--green button--outline close-filter">View results</div>
        </div>
    </div>
</template>

<script>
    import FilterBlock from "./FilterBlock";
    import {useStore} from 'vuex';
    import {mapGetters} from "vuex";

    export default {

        data() {
            return {
                filterCategories: '',
                localFilters: []
            }
        },

        computed: {
            ...mapGetters({
                filterTrigger: 'filterTrigger'
            })
        },
        components: {
            'filter-block': FilterBlock
        },
        methods: {
            resetAllFilters() {
                this.$store.commit('resetFilters');
            },
            setFiltersInState() {
                const store = useStore();
                const filterFromEl = document.getElementById('posts').getAttribute('data-filter-categories');
                const filtersParsed = (filterFromEl) ? JSON.parse(filterFromEl) : [];

                if (filtersParsed.length > 0) {
                    filtersParsed.forEach((value, index) =>  {
                        let tempVal = value.filter_category;
                        tempVal.label = value.filter_label;
                        tempVal.hidden = value.filter_hidden;
                        tempVal.type = value.filter_type;

                        filtersParsed[index] = tempVal;
                    });
                } else {
                    this.$store.state.hideFilters = true;
                }

                if (typeof filtersParsed === 'object') {
                    store.commit('initializeFiltersState', filtersParsed);
                    this.localFilters = filtersParsed;
                } else {
                    console.error("No filters set in 'data-categories' attribute in #posts element");
                }
            },
            toggleFilterVisibility() {
                this.$store.state.filtersShow = false;
            },
            closeFilter() {
                let _this = this;
                document.body.addEventListener('click', (event) => {
                    if (_this.$store.state.filtersShow === true && !event.target.classList.contains('filter-toggle')) {
                        let elParents = this.getParents(event.target);
                        let parentClass = false;
                        elParents.forEach(function(value) {
                            if (value.classList) {
                                if (value.classList.contains('posts__filter')) {
                                    parentClass = true;
                                }
                            }
                        });
                        if (parentClass === false) {
                            this.$store.state.filtersShow = false;
                        }
                    }
                });
            },
            getParents(el, parentSelector /* optional */) {

                // If no parentSelector defined will bubble up all the way to *document*
                if (parentSelector === undefined) {
                    parentSelector = document;
                }

                var parents = [];
                var p = el.parentNode;

                while (p !== parentSelector) {
                    var o = p;
                    parents.push(o);
                    p = o.parentNode;
                }
                parents.push(parentSelector); // Push that parentSelector you wanted to stop at

                return parents;
            }
        },
        created() {
            this.setFiltersInState();
            this.closeFilter();
        }
    }
</script>
